export const BANNER_CONFIG = {
  ANIMATION_DURATION: 850,
  BANNER_INTERVAL: 3000,
  IMAGE_TRANSITION_DELAY: 850,
} as const;

export const BANNER_DIMENSIONS = {
  MOBILE: {
    MIN_HEIGHT: 180,
    BORDER_RADIUS: 8,
  },
  TABLET: {
    MIN_HEIGHT: 280,
    HEIGHT: 572,
    BORDER_RADIUS: 32,
  },
  DESKTOP: {
    HEIGHT: 320,
    MIN_HEIGHT: 320,
    MAX_WIDTH: 500,
    BORDER_RADIUS: 32,
  },
} as const;

export const BANNER_SPACING = {
  MOBILE: {
    PADDING_X: 20,
    PADDING_BOTTOM: 48,
    PADDING_TOP: 32,
    GAP: 40,
    TITLE_MARGIN_BOTTOM: 16,
    SECTION_MARGIN_BOTTOM: 12,
  },
  TABLET: {
    PADDING_X: 0,
    PADDING_Y: 80,
    PADDING_TOP: 28,
    GAP: 40,
    TITLE_MARGIN_BOTTOM: 24,
    SECTION_MARGIN_BOTTOM: 24,
  },
  DESKTOP: {
    GAP: 56,
    PADDING_BOTTOM: 80,
  },
} as const;

export const BANNER_ANIMATION_DELAYS = {
  SECOND_BANNER: -9,
  THIRD_BANNER: -6,
  FOURTH_BANNER: -3,
} as const;
